import { api, unwrap } from './http';

export default {
  getLoggedInUserPermissions: async () => unwrap(api.get('/AuthActions/GetUserAuthActions')),

  // Owner-consent account linking (public — the emailed token is the proof of intent).
  approveAccountLink: async (token) => unwrap(api.post('/Auth/AccountLink/Approve', { token })),

  rejectAccountLink: async (token) => unwrap(api.post('/Auth/AccountLink/Reject', { token })),
};
